export default "__VITE_ASSET__Cu44YsX2__"